<template>

    <div class="row" v-if="usergroup !== null">
        <div class="col-md-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Gebruikersgroep bekijken: {{ usergroup.name }}</h2>
                    <div class="box-tools">
                        <router-link
                            :to="{name:'hr.usergroups.edit', params:{id: usergroup.uuid}}"
                            class="btn btn-xs btn-primary"
                            v-tooltip="'Gebruikersgroep bewerken'"
                        >
                            <i class="mdi mdi-pencil"></i>
                            <span class="sr-only">Gebruikersgroep bewerken</span>
                        </router-link>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="col-md-6">Naam</th>
                                <td>{{ usergroup.name }}</td>
                            </tr>
                            <tr>
                                <th>Beschrijving</th>
                                <td>{{ usergroup.description }}</td>
                            </tr>
                            <tr>
                                <th>Huidig tarief</th>
                                <td>{{ usergroup.rate | toCurrency }}</td>
                            </tr>
                            <tr>
                                <th>Actief percentage</th>
                                <td>{{ usergroup.active }}%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Tarief geschiedenis</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th class="col-md-6">Datum</th>
                                <th class="text-right">Tarief</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="usergroup.rates_history.length === 0"><td colspan="2">Er zijn geen tarieven gevonden</td></tr>
                            <tr v-for="rate in usergroup.rates_history">
                                <td>{{ rate.created_at | formatDateTime }}</td>
                                <td class="text-right">{{ rate.rate | toCurrency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Medewerkers in deze groep</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="usergroup.users.length === 0"><td colspan="2">Er zijn geen medewerkers gevonden in deze groep</td></tr>
                            <tr v-for="user in usergroup.users">
                                <td>{{ user.fullname }}</td>
                                <td class="text-right">
                                    <router-link
                                        :to="{name:'hr.users.show', params:{uuid:user.uuid}}"
                                        class="btn btn-xs btn-default"
                                        v-tooltip="'Gebruiker bekijken'"
                                    >
                                        <i class="mdi mdi-eye"></i>
                                        <span class="sr-only">Gebruiker bekijken</span>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-5">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Permissie groepen</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Toegang</th>
                                <th class="col-xs-2 text-center">Lezen</th>
                                <th class="col-xs-2 text-center">Schrijven</th>
                                <th class="col-xs-2 text-center">Admin</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(permissions, group) in getHrPermissions"
                                v-if="group !== 'system'"
                            >
                                <td>{{ lang.get('permissions.groups.' + group) }}</td>
                                <td
                                    v-for="permission in permissions"
                                    class="text-center"
                                >
                                    <label>
                                        <input
                                            type="checkbox"
                                            :value="permission.id"
                                            v-model="groupPermissions"
                                        />
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="box-body">
                    <p>Toegang tot de financiele, HR en planning modules worden via de licentie pagina vergeven.</p>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Losse permissies</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Permissie</th>
                                <th class="text-center">Toegang</th>
                            </tr>
                        </thead>
                        <tbody
                            v-for="(permissions, group) in getHrPermissions"
                            v-if="group === 'system'"
                        >
                            <tr
                                v-for="permission in permissions"
                            >
                                <td>{{ lang.get('permissions.permissions.' + permission.name) }}</td>
                                <td class="text-center">
                                    <label>
                                        <input
                                            type="checkbox"
                                            :value="permission.id"
                                            v-model="groupPermissions"
                                        />
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="text-right">
                <button
                    class="btn btn-primary btn-sm"
                    type="submit"
                    :disabled="!canSubmit"
                    @click="onSubmit"
                >
                    Permissies opslaan
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters } from "vuex";
import Lang from "../../../Lang";

export default {

    computed: {
        ...mapGetters([
            'getHrPermissions',
            'getHrUsergroups',
        ]),

        canSubmit() {
            return this.posting === false;
        },

        postData() {
            return {
                permissions: this.groupPermissions,
            };
        },

        usergroup() {
            if (!this.$route.params.uuid) {
                return null;
            }

            let usergroup = this.getHrUsergroups.filter(group => group.uuid === this.$route.params.uuid);

            return usergroup.length === 1 ?
                usergroup[0] :
                null;
        },
    },

    data() {
        return {
            groupPermissions:[],
            lang:Lang,
            posting:false,
        }
    },

    metaInfo: {
        title:'Usergroup',
    },

    methods: {
        onSubmit() {
            if (!this.canSubmit) {
                return;
            }

            this.posting = true;

            axios.post(this.route('api.v1.hr.usergroups.permissions', this.usergroup.uuid), this.postData)
                .then(() => {
                    this.$snotify.success('De gebruikersgroep permissies zijn opgeslagen');
                    this.$emit('updateUsergroups');
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het opslaan van de gebruikersgroep permissies'))
                .finally(() => this.posting = false);
        },

        setUsergroupPermissions() {
            if (this.usergroup !== null) {
                this.groupPermissions = JSON.parse(JSON.stringify(this.usergroup.permissions));
            }
        },
    },

    mounted(){
        this.setUsergroupPermissions();
    },

    name:'HrUsergroupsShow',

}

</script>
